export const TABLE_STATE_CHANGE = "TABLE_STATE_CHANGE";
export const TABLE_LOADING = "TABLE_LOADING";

export const SAGA_TABLE_STATE_CHANGE = "SAGA_TABLE_STATE_CHANGE";
export const SAGA_DO_FETCH_DATA = "SAGA_DO_FETCH_DATA";
export const SAGA_INIT_OPEN_REQS = "SAGA_INIT_OPEN_REQS";

export class Saga {
  static initialise(qs) {
    return {
      type: SAGA_INIT_OPEN_REQS,
      qs
    }
  };
  static tableStateChange(stateToChange) {
    return {
      type: SAGA_TABLE_STATE_CHANGE,
      stateToChange
    }
  };
  static doFetchData() {
    return {
      type: SAGA_DO_FETCH_DATA
    }
  };
}


export class Generator {
  static tableStateChange(stateToChange) {
    return {
      type: TABLE_STATE_CHANGE,
      stateToChange
    }
  };
  static loading(loading) {
    return {
      type: TABLE_LOADING,
      loading
    }
  };
}